import { GatewayId } from '../models/gateway';

export const BEECON_GATEWAY_PREFIX = '16';

// Beecon boxes are not compatible with remote diagnostic yet.
export function isBeeconGateway(gatewayId: GatewayId): boolean {
    return gatewayId.startsWith(BEECON_GATEWAY_PREFIX);
}
